<div class="input-container">
  <div class="inputs">
    <button
      class="control-button"
      (click)="!disabled && clickedMinus()"
      [ngClass]="{'control-button--disabled': isMinusBtnDisabled}"
      [disabled]="isMinusBtnDisabled"
      [attr.data-cy]="'button-minus' + (minusBtnTestId ? (' ' + minusBtnTestId) : '')"
      >
      <svg-icon src="assets/icons/minus.svg" [svgStyle]="{ 'width.px':15 }"></svg-icon>
    </button>
    <div
      class="input-value-container"
      [ngClass]="{
        'input-value-container--disabled': disabled,
        'input-value-container--invalid': invalidInput(),
        'input-value-container--efektika-nullified': (efektikaMode && +currentInputValue === 0) || efektikaEditingMode
      }"
      >
      <input
        class="input-value"
        (input)="textInputUpdated()"
        [(ngModel)]="currentInputValue"
        [disabled]="disabled"
        [ngClass]="{'input-value-container--disabled': disabled}"
        [attr.data-cy]="'plus-minus-input' + (minusBtnTestId ? (' ' + minusBtnTestId) : '')"
        >
        <div class="input-units" >
          @if (options.displayUnits) {
            {{ options.displayUnits }}
          }
          @if (digitShortcutsOptions?.units && !options.displayUnits) {
            {{ currentValue | currencyDigitShortcut: digitShortcutsOptions:true }}
          }
        </div>
      </div>
      <button
        class="control-button"
        [ngClass]="{'control-button--disabled': isPlusBtnDisabled}"
        [disabled]="isPlusBtnDisabled"
        (click)="!isPlusBtnDisabled && clickedPlus()"
        data-cy="button-add"
        >
        <svg-icon src="assets/icons/plus.svg" [svgStyle]="{ 'width.px':15 }"></svg-icon>
      </button>
    </div>

    <div class="slide-container">
      @if(options.minValue > 0 && !options.allowZero && !(options.minValue === options.step)) {
        <div
          class="disabled-bar-placeholder"
          [style]="{'width': ((options.minValue/options.maxValue) * 100) + '%'}"
          [attr.data-cy]="'plus-minus-input-min-disabled-slider ' + (minusBtnTestId ? minusBtnTestId : '')"
        ></div>
      }
      <input
        class="slider"
        type="range"
        min="{{ options.allowZero ? 0 : options.minValue }}"
        max="{{ options.maxValue }}"
        step="{{ options.step }}"
        [(ngModel)]="currentValue"
        (input)="sliderInputUpdated($event)"
        [disabled]="disabled"
        data-cy="input-slider"
        [style]="{'width': ((100-((options.minValue/options.maxValue) * 100)) + 4) + '%'}"
        >
      </div>

      <div class="risk-bar mt-1">
        <span [attr.data-cy]="'plus-minus-input-min-value ' + (minusBtnTestId ? minusBtnTestId : '')">
          @if(options.sliderStartAtLowestStep) {
            {{ options.step | currencyDigitShortcut: digitShortcutsOptions }} {{ options.displayUnits }}
          } @else if (options.allowZero || options.minValue > 0 && !options.sliderStartAtLowestStep) {
            0
          } @else {
            {{ options.minValue | currencyDigitShortcut: digitShortcutsOptions }} {{ options.displayUnits }}
          }
        </span>
        <span [attr.data-cy]="'plus-minus-input-max-value ' + (minusBtnTestId ? minusBtnTestId : '')">
          {{ options.maxValue | currencyDigitShortcut: digitShortcutsOptions }} {{ options.displayUnits }}
        </span>
      </div>
    
    </div>
